module.exports = __webpack_public_path__ + "assets/img/budapark3-640.317f47a3.webp";